/**
 * Official Atlassian javascript library for Confluence REST API calls.
 * @module confluence-rest-api
 */

import requestHelper from './request-helper.js';
const fetch = requestHelper.fetch;
export { fetch };

/**
 * Configures all API helpers.
 * @param {Object} configuration
 */
export function configure(configuration) {
	requestHelper.configure(configuration);
}

export function getAtlToken() {
	return requestHelper.getAtlToken();
}

/**
 * Helper methods for fetching spaces.
 */
export { space } from './spaces.js';

/**
 * Helper methods for fetching content.
 */
export {
	editPageMetadata,
	editorPage,
	publishEditorPage,
	syncEditorDraft,
	publishEditorPageFromTemplate,
	createPage,
	draftMetadata,
	cancelScheduledPublish,
} from './content.js';

/**
 * Helper methods related to features.
 */
export { markDiscovered } from './feature-discovery.js';

/**
 * Helper methods related to page labels.
 */
export { suggest } from './labels.js';

/**
 * Helper methods related to the editor.
 */
export {
	getPluginCodeLanguages,
	getWikiConfluenceToXhtml,
	getWikiMarkdownToXhtml,
} from './editor.js';

/**
 * Helper methods related to content properties.
 */
export { updateContentProperty } from './contentProperties.js';

/**
 * Transformer functions.
 */
export {
	spaceResponseTransformer,
	contentsWithBodyResponseTransformer,
	editorContentsWithBodyResponseTransformerV2,
} from './transformers.js';

export { userTransformer } from './transformers/users.js';
export { isSpa } from './transformers/helpers.js';
